var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "M79.748 34.72c-.044-.128-.08-.252-.132-.376-.196-.424-.44-.828-.784-1.172l-24-24c-.344-.344-.748-.588-1.172-.784-.12-.056-.248-.088-.376-.132a3.966 3.966 0 0 0-1.036-.204C52.16 8.044 52.084 8 52 8H24c-4.412 0-8 3.588-8 8v64c0 4.412 3.588 8 8 8h48c4.412 0 8-3.588 8-8V36c0-.084-.044-.16-.052-.248a3.963 3.963 0 0 0-.2-1.032zM66.344 32H56V21.656L66.344 32zM24 80V16h24v20c0 2.212 1.788 4 4 4h20l.008 40H24z"
  })));
};
export default SvgFile;